module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-info banner-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.size))]), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('input', {
    staticClass: "input-with-btn",
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "readonly": ""
    },
    domProps: {
      "value": ("<a href=\"" + _vm.url + "?mpc=" + _vm.utm_medium + "&utm_medium=" + _vm.utm_medium + "&utm_source=" + _vm.utm_source + "&utm_brand=" + _vm.utm_brand + "&utm_campaign=" + _vm.utm_campaign + "&utm_content=" + _vm.size + "\" target=\"_blank\" rel=\"dofollow\"><img src=\"" + _vm.imageUrl + "\" alt=\"Punkta.pl – porównywarka OC\"></a>")
    },
    on: {
      "focus": _vm.select
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-flat btn-copy",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.copyUrl
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/copy-icon.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "banner-image",
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0c7e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banners/bannerUrl.vue
// module id = 359
// module chunks = 0